import type { MessageHandlerDeps } from '../../routing/message-handler-deps.js';
import { yieldToEventLoop } from '../../runtime/yield-to-event-loop.js';
import { readPersistedQueue } from '../disk-store.js';
import { dispatchLocalPrompt } from './dispatch-local-prompt.js';
import { getRunIdQueueKey } from './run-id-queue-key-map.js';
import type { PromptQueueSnapshotEntries } from './prompt-queue-snapshot-types.js';

export async function dispatchStartedPromptQueueRuns(
  entries: PromptQueueSnapshotEntries,
  started: Set<string>,
  deps: MessageHandlerDeps,
): Promise<void> {
  for (const [queueKey] of entries) {
    const file = await readPersistedQueue(queueKey);
    const running = file?.turns.find((turn) => turn.lastCliState === 'running');
    if (running && started.has(running.turnId) && getRunIdQueueKey(running.turnId) === queueKey) {
      dispatchLocalPrompt(running, deps);
    }
    await yieldToEventLoop();
  }
}
